export default __webpack_public_path__ + "static/image4-8efed1e5cf61a60287b3b0cdfadddbf8.gif";